<template>
  <div class="details">
    <div class="swiperBox">
      <details-swiper
        :swiperList="swiperList"
        :videoUrl="productVideo"
        ref="detailsSwiper"
      ></details-swiper>
      <details-title :productInfo="productInfo"></details-title>
    </div>
    <!-- 产品信息 -->
    <product-info :productInfo="productInfo"></product-info>
    <!-- 产品描述 -->
    <spec :productInfo="productInfo"></spec>
    <section class="btBox">
      <button class="addShop" @click="getSku('addShop')">
        {{ $t.shopping.addShop }}
      </button>
    </section>
    <sku :type="type" :showSku="showSku" @hideSku="hideSku"></sku>
  </div>
</template>
<script>
import DetailsSwiper from "./components/DetailsSwiper";
import DetailsTitle from "./components/DetailsTitle";
import ProductInfo from "./components/ProductInfo";
import Spec from "./components/Spec";
import Sku from "@main/sku/Sku";
import { mapState, mapMutations } from "vuex";
import { SET_PRODUCTINFO } from "@/store/mutation-types";
import Vue from "vue";
import { Image } from "vant";

Vue.use(Image);
export default {
  name: "Details",
  components: {
    DetailsSwiper,
    DetailsTitle,
    ProductInfo,
    Spec,
    Sku,
  },
  data() {
    return {
      showSku: false,
      type: "addShop",
      isPlaceholder: false,
      shopId: "",
      productNumber: "",
      swiperList: [],
      productVideo: null,
    };
  },
  watch: {
    $route(to, from) {
      if (to.query !== from.query) {
        const { ShopId, ProductNumber } = this.$route.query;
        this.shopId = ShopId;
        this.productNumber = ProductNumber;
        this.loadProductInfo();
      }
    },
  },
  computed: {
    ...mapState({
      productInfo: (state) => state.details.productInfo,
    }),
  },
  destroyed() {
    this.SET_PRODUCTINFO({});
  },
  beforeMount() {
    const { ShopId, ProductNumber } = this.$route.query;
    this.shopId = ShopId;
    this.productNumber = ProductNumber;
  },
  mounted() {
    this.loadProductInfo();
  },
  methods: {
    ...mapMutations([SET_PRODUCTINFO]),
    videoUrlFilter(value) {
      return this.$api.formatVideoUrl(value);
    },
    loadProductInfo() {
      this.$commonMethod.showLoading();
      let param = {
        ShopId: this.shopId,
        BProductNumber: this.productNumber,
      };
      this.$api.product
        .loadProductInfo(param)
        .then((res) => {
          const data = res.data;
          this.SET_PRODUCTINFO(data);
          this.swiperList = data.ProductPhoto.split("|");
          if (data.ProductVideo) {
            this.productVideo = this.videoUrlFilter(data.ProductVideo);
          }
          // this.productVideo = this.videoUrlFilter(
          //   "UploadFiles/file/05/202405141747234455.mp4"
          // );
          this.$nextTick((_) => {
            this.$refs.detailsSwiper.onloadVideos();
          });
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
            status: error.status,
          });
        });
    },
    getSku(type) {
      this.showSku = true;
      this.type = type;
    },
    hideSku() {
      this.showSku = false;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~assets/scss/publicStyle.scss";
.details {
  width: 100%;
  .swiperBox {
    position: relative;
    width: 100%;
  }
  .shopBox {
    position: relative;
    width: 100%;
    text-align: center;
    margin-top: 15px;
    .van-button {
      width: 90%;
      color: #999;
    }
  }
  .btBox {
    width: 100%;
    margin: 0 auto;
    position: fixed;
    box-sizing: border-box;
    -webkit-box-sizing: border-box;
    bottom: 0;
    margin-top: 25px;
    background-color: #f6f6f6;
    border-top: 0.1rem solid #e5e5e5;
    justify-content: space-between;
    -webkit-justify-content: space-between;
    padding-left: 4%;
    padding-right: 4%;
    padding-top: 2%;
    padding-bottom: calc(2% + env(safe-area-inset-bottom));
    @include publicFlex;
    .addShop {
      outline: none;
      margin: 0;
      padding: 0;
      border: none;
      width: 100%;
      background-color: #132660;
      color: #ffffff;
      border-radius: 30px;
      height: 42.5px;
      font-size: 17px;
    }
  }
}
</style>
